import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

// Service
import { ApiService } from '../../shared/service/api.service';
import { GlobalService } from 'src/app/shared/service/global.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styles: [
  ]
})
export class SearchComponent implements OnInit {

  search = new FormControl('');
  keyword;
  searchResultNews = [];
  searchResultSection = [];
  searchResultMenu = [];
  isLang;
  loading;
  searchSubscription: Subscription;

  constructor( 
    private router : Router, 
    private activedRoute: ActivatedRoute,
    private apiService: ApiService,
    public globalService : GlobalService
  ) { }

  ngOnInit(): void {
    this.searchSubscription = this.activedRoute.queryParams.subscribe(params => {
      this.loading = true;
      this.search.setValue(params.key);
      this.keyword = params.key;
      // MultiLanguage
      this.isLang = this.apiService.isLang();
      if (params.key == null || params.key == ''){
        this.searchResultNews = [];
        this.searchResultSection = [];
        this.searchResultMenu = [];
        this.loading = false;
      } else {
        this.apiService.getDataApi(`search?key=${params.key}`).subscribe(response => {
          this.searchResultNews = [];
          this.searchResultSection = [];
          this.searchResultMenu = [];
          response.news_release.forEach((v, i) => {
            this.searchResultNews.push(v);
          });
          response.section.forEach((v, i) => {
            this.searchResultSection.push(v);
          });
          response.menu.forEach((v, i) => {
            this.searchResultMenu.push(v);
          });
          this.loading = false;
        });
      }
      // Meta
      this.globalService.updateMeta(
        'Search' + ' | Prime Agri Resources',
        'page search Prime Agri Resources',
        'Page Search Prime Agri Resources'
      );
    });
  }

  onSearch(ev){
    if (ev.keyCode === 13 || ev.type === 'click' ) {
      this.router.navigate(['/search'], { queryParams: { key: this.search.value } });
    }
  }

  ngOnDestroy() {
    this.searchSubscription.unsubscribe();
  }

}
